import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';


export default class Textarea extends React.Component<
  any
> {

	// constructor(props) {
 //      super(props);
 //      this.state = {
 //      	value: 'Hello Runoob!'
 //      };
 //      this.handleChange = this.handleChange.bind(this);
 //  	}
 	// private handleChange = (event: React.ChangeEvent<HTMLInputElement>,name) => {
  //     console.log(event.target.value)
  //     this.setState({
  //       name:event.target.value
  //     })
  // 	} 

	public render() {
    	const { valueChange, value, className, placeholder, ...restProps } = this.props;
    	return (
    		<textarea 
            	value={value} 
            	className={cx(styles.TextareaBox, className)} 
            	placeholder={placeholder}
            	onChange={valueChange.bind(null,this.props.name)}
            	{...restProps}
            />
    	)
            
  	}
}
